
<template>
 <div class="alert alert-info d-flex" :class="custom_class">
      
    <span>
        <font-awesome-icon :icon="[icon_class ? icon_class : 'fa', icon ? icon : 'info-circle']" v-if="show_icon"/>
        <span class="pl-2" v-html="alert_text"></span>
    </span>

  </div>
</template>
<script>
    export default {
        props: {
            alert_text: String,
            icon: String,
            icon_class: String,
            show_icon: Boolean,
            custom_class: String
        },
    }
</script>
